import { getRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const getStats = () => getRequest(apiEndpoints.stats.stats);
